import React, { Component } from "react";
import styled from "styled-components";
import { Login } from "Apollo";
import { ShowNotice } from "Store";
import NotificationBox from "module-common/NotificationBox";
import TextInput from "./TextInput";
import { CurrentTheme } from "theme";

export default class ModuleLogin extends Component {
  state = {
    company: "",
    username: "",
    password: ""
  };

  render() {
    const { company, username, password } = this.state;
    const loginImageTop = CurrentTheme.loginImageTop;
    const loginImageMiddle = CurrentTheme.loginImageMiddle;
    const loginImageBottom = CurrentTheme.loginImageBottom;
    const loginBrandText = CurrentTheme.loginBrandText;

    return (
      <Screen>
        <ImageLogin>
          <LogoCare alt="" src={loginImageTop} />
          <img alt="" src={loginImageMiddle} />
          <LogoNoLimit alt="" src={loginImageBottom} />
        </ImageLogin>
        <Panel onSubmit={event => event.preventDefault()}>
          <NotificationBox />
          <Title>
            Hello there,
            <br />
            <strong>{loginBrandText}</strong>
          </Title>
          <TextInput
            label="Company"
            value={company}
            onChange={e => this.setState({ company: e.target.value })}
          />
          <TextInput
            label="Username"
            value={username}
            onChange={e => this.setState({ username: e.target.value })}
          />
          <TextInput
            label="Password"
            isPassword
            value={password}
            onChange={e => this.setState({ password: e.target.value })}
          />
          <Row />

          <SecButton>
            {CurrentTheme.trial && (
              <TrialButton
                size="large"
                color="white"
                type="button"
                rounded
                onClick={async () => {
                  window.location = "/trial";
                }}
              >
                Free Trial
              </TrialButton>
            )}

            <Sign
              size="large"
              color="white"
              type="submit"
              rounded
              onClick={async () => {
                if (await Login(company, username, password)) {
                  // use window location to remove store cache
                  window.location = "/case-management";
                } else {
                  ShowNotice("login-error");
                }
              }}
            >
              Sign in
            </Sign>
          </SecButton>
        </Panel>
      </Screen>
    );
  }
}

const Screen = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.loginBackground};
`;
const Title = styled.span`
  font-size: 1.5rem;
  color: white;
  margin-bottom: 30px;
`;
const Panel = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: none;
  width: 500px;
  padding: 60px;
  margin-left: 50px;
  border-radius: 10px;
  background: ${props => props.theme.panelLoginBackground};
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -6px;
  margin-bottom: 40px;
`;
const ImageLogin = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
`;
const LogoCare = styled.img`
  width: 400px;
  height: auto;
  margin: auto;
`;
const LogoNoLimit = styled.img`
  width: 115px;
  height: 60px;
  margin: auto;
  margin-top: 35px;
`;
const TrialButton = styled.button`
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px solid #fff;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  border-radius: 20px;
  white-space: nowrap;
  user-select: none;
  background: transparent;
  flex: 1;
  margin-right: 10px;
  padding: 8px 8px 12px;
  font-size: 14px;
  &:focus {
    outline: none;
  }
  &:hover {
    background: #fff;
    color: #0c8dbf;
  }
`;
const Sign = styled.button`
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #238fc1;
  transition: 0.3s;
  cursor: pointer;
  border-radius: 20px;
  white-space: nowrap;
  user-select: none;
  background: #ffffff;
  flex: 1;
  padding: 8px 8px 12px;
  border: none;
  font-size: 14px;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const SecButton = styled.section`
  display: flex;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/module-login/ModuleLoginWithMutation.js